import React from 'react';
import { Link } from 'react-router-dom';
import qs from 'qs'
import { connect } from 'react-redux';
import { userService } from '../../_services';

class ConfirmEmailPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state ={
            isConfirmed : false
        }
    }

    componentDidMount(){
        const values = qs.parse(this.props.location.search , { ignoreQueryPrefix: true });

        userService.confirmEmail(values.email , encodeURIComponent(values.code))
        .then (response => {
            if(response){
                this.setState({
                    isConfirmed : true
                });
            }
        })
    }

    render(){
        const {loading , alert} = this.props;

        return (
            <div>
                {alert.message && 
                    <h6>{alert.message}</h6>
                }
                
                {
                    (this.state.isConfirmed === true) && 
                    <div>
                        <h6>Thank you for confirming email</h6>
                        <p className="m-t-md">Please continue <Link to="/login" >Signing In</Link></p>
                    </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading , alert } = state;
    return {
        loading , alert
    };
}

const connected = connect(mapStateToProps)(ConfirmEmailPage);
export { connected as ConfirmEmailPage }; 



// WEBPACK FOOTER //
// ./src/Views/ConfirmEmailPage/ConfirmEmailPage.jsx